// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file patients/create_patient.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message com.neulink.pharmacy.CreatePatientRequest
 */
export class CreatePatientRequest extends Message<CreatePatientRequest> {
  /**
   * Full name of the patient
   *
   * @generated from field: string name = 1;
   */
  name = "";

  /**
   * Phone number of the patient
   *
   * @generated from field: string phone = 2;
   */
  phone = "";

  /**
   * Government-issued identifier (e.g., national ID, passport)
   *
   * @generated from field: string govt_identifier = 3;
   */
  govtIdentifier = "";

  constructor(data?: PartialMessage<CreatePatientRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CreatePatientRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "govt_identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreatePatientRequest {
    return new CreatePatientRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreatePatientRequest {
    return new CreatePatientRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreatePatientRequest {
    return new CreatePatientRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreatePatientRequest | PlainMessage<CreatePatientRequest> | undefined, b: CreatePatientRequest | PlainMessage<CreatePatientRequest> | undefined): boolean {
    return proto3.util.equals(CreatePatientRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.CreatePatientResponse
 */
export class CreatePatientResponse extends Message<CreatePatientResponse> {
  /**
   * @generated from field: string patient_id = 1;
   */
  patientId = "";

  constructor(data?: PartialMessage<CreatePatientResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.CreatePatientResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "patient_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreatePatientResponse {
    return new CreatePatientResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreatePatientResponse {
    return new CreatePatientResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreatePatientResponse {
    return new CreatePatientResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreatePatientResponse | PlainMessage<CreatePatientResponse> | undefined, b: CreatePatientResponse | PlainMessage<CreatePatientResponse> | undefined): boolean {
    return proto3.util.equals(CreatePatientResponse, a, b);
  }
}

